import { model, models, Schema, Types } from "mongoose";
import { ITokenImp } from "./types";

const TokenImpSchema = new Schema<ITokenImp>(
  {
    chainId: { type: Number, required: true },
    packageIndex: { type: Number, required: true },
    address: {
      type: String,
      required: true,
    },
    isUniswapV3Compatible: {
      type: Boolean,
      default: false,
    },
  },
  {
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret: any) => {
        ret.id = ret._id.toString();
        delete ret._id;
      },
    },
  }
);

TokenImpSchema.index({ chainId: 1, packageIndex: 1 });

export const TokenImpModel =
  models?.TokenImp || model<ITokenImp>("TokenImp", TokenImpSchema);
